import PACKAGE_JSON from '../../../package.json'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const { version } = PACKAGE_JSON

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const getRelease = () => `wellbeing@${version}`
